import { CommonService } from "../common.service";
import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";
import { StoreService } from '../store.service';
var CasePracticeTeamReportComponent = (function () {
    function CasePracticeTeamReportComponent(commonService, apiService, route, router, storeService) {
        this.commonService = commonService;
        this.apiService = apiService;
        this.route = route;
        this.router = router;
        this.storeService = storeService;
        this.assetsRoute = "../../assets";
    }
    CasePracticeTeamReportComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        var that = this;
        this.isShowReportLv = false;
        this.subWrapTwoShow = true;
        this.btnWrapShow = true;
        this.tourReviewShow = true;
        this.tourReviewBoxShow = false;
        this.bestPathBoxShow = false;
        this.analysisBoxShow = false;
        this.starShow = false;
        this.pathClickable = true;
        this.redoClickedStatus = false;
        this.goToListClickedStatus = false;
        this.route.queryParams.subscribe(function (queryParams) {
            _this.type = queryParams['type'];
        });
        this.route.params.subscribe(function (params) {
            _this.multiExerciseMetaId = params['multiExerciseMetaId'];
            _this.learningPathId = params['learningPathId'];
            _this.practiceMetaId = params['practiceMetaId'];
            _this.apiService.ajax({
                'type': 'get',
                'url': '/api/multiFinish/' + _this.multiExerciseMetaId
            }).subscribe(function (result) {
                _this.report = result;
                $.ajax({
                    url: "/sr/insideapi/getlevel",
                    // url: "http://47.96.183.37:10050/ddi/insideapi/getlevel",
                    type: "post",
                    dataType: 'json',
                    contentType: 'application/json;charset=utf-8',
                    data: JSON.stringify(_this.getKaList(result)),
                    async: false,
                    headers: {
                        'transtalen-token': localStorage.getItem('transtalen-token') ? localStorage.getItem('transtalen-token') : '',
                        'transtalenuserid': localStorage.getItem('transtalenuserid') ? localStorage.getItem('transtalenuserid') : ''
                    },
                    success: function (result) {
                        if (result && result != "") {
                            that.reportKAData = result;
                            that.targetShow = 1;
                        }
                        else {
                            that.targetShow = 0;
                        }
                    },
                    error: function (er) {
                        that.targetShow = 0;
                        if (er.status === 401 && Number(er.responseJSON.code) === 106) {
                            that.storeService.notification.notAuthed.next(true);
                        }
                    }
                });
                if (that.targetShow === 0) {
                    _this.isShowReportLv = false;
                }
                else {
                    _this.isShowReportLv = true;
                }
                // this.reportKAData = this.getKaList(result);
                // this.isShowReportLv = true;
            });
            /*this.report = this.getMockData();
            this.chuanjie = 'test';
            console.log(this.report);*/
        });
        this.apiService.ajax({
            'type': 'get',
            'url': '/sr/learningtour',
        }).subscribe(function (result) {
            _this.learningTour = result;
        });
        // this.apiService.ajax({
        //   'type': 'get',
        //   'url': '/api/concatenation/' + this.learningPathId,
        //   'data': {
        //     'learningPathId': this.learningPathId,
        //   }
        // }).subscribe(comment => { this.chuanjie = comment[2].comment; });
    };
    CasePracticeTeamReportComponent.prototype.ngAfterViewInit = function () {
        var that = this;
        this.commonService.initPage({
            'backgroundColor': 'white'
        });
        $(document).ready(function () {
            var listenerTimeout = setInterval(function () {
                var bestPathEle = document.getElementById('bestPathBox'), analysisEle = document.getElementById('analysisContent'), tutorEle = document.getElementById('tourReviewBox');
                if (bestPathEle !== null && analysisEle !== null && tutorEle != null) {
                    bestPathEle.addEventListener('scroll', that.onBestPathScroll);
                    analysisEle.addEventListener('scroll', that.onAnalysisScroll);
                    tutorEle.addEventListener('scroll', that.onTutorScroll);
                    clearInterval(listenerTimeout);
                }
            }, 500);
        });
    };
    /*
    格式化KA对象方法
     report：传递一个报告对象
   */
    CasePracticeTeamReportComponent.prototype.getKaList = function (report) {
        var kaJson = { id: this.learningPathId, name: "打造高效团队", type: "exercise", kas: {}, exercisesId: this.practiceMetaId, questionId: null, optionId: null };
        if (report) {
            for (var i = 1; i <= 6; i++) {
                var kaItem = report["ka" + i];
                if (kaItem) {
                    //kaJson.kas.push({name:kaItem.name,value:kaItem.total});
                    kaJson.kas[kaItem.name] = kaItem.total;
                }
            }
        }
        return kaJson;
    };
    CasePracticeTeamReportComponent.prototype.close = function () {
        var link = ['case-practice-team', this.learningPathId, this.practiceMetaId, 1, 0];
        if (this.type) {
            this.router.navigate(link, { queryParams: { type: 'huatek' } });
        }
        else {
            this.router.navigate(link);
        }
    }; // end of close
    CasePracticeTeamReportComponent.prototype.redo = function () {
        var _this = this;
        if (!this.pathClickable || this.redoClickedStatus) {
            return;
        }
        else {
            this.redoClickedStatus = true;
        }
        this.apiService.ajax({
            'type': 'get',
            'url': '/api/multi/' + this.multiExerciseMetaId + '/reset'
        }).subscribe(function (result) {
            var link = ['case-practice-team-begin', _this.multiExerciseMetaId, _this.learningPathId, _this.practiceMetaId];
            if (_this.type) {
                _this.router.navigate(link, { queryParams: { type: 'huatek' } });
            }
            else {
                _this.router.navigate(link);
            }
        });
    }; // end of redo
    CasePracticeTeamReportComponent.prototype.onBestPathScroll = function () {
        var overlay = document.getElementById('bestPathBox');
        if (overlay.scrollTop < 1) {
            overlay.scrollTop = 1;
        }
        else if (overlay.scrollHeight - overlay.scrollTop - overlay.clientHeight < 1) {
            overlay.scrollTop = overlay.scrollTop - 1;
        }
    };
    CasePracticeTeamReportComponent.prototype.onAnalysisScroll = function () {
        var overlay = document.getElementById('analysisContent');
        if (overlay.scrollTop < 1) {
            overlay.scrollTop = 1;
        }
        else if (overlay.scrollHeight - overlay.scrollTop - overlay.clientHeight < 1) {
            overlay.scrollTop = overlay.scrollTop - 1;
        }
    };
    CasePracticeTeamReportComponent.prototype.onTutorScroll = function () {
        var overlay = document.getElementById('tourReviewBox');
        if (overlay.scrollTop < 1) {
            overlay.scrollTop = 1;
        }
        else if (overlay.scrollHeight - overlay.scrollTop - overlay.clientHeight < 1) {
            overlay.scrollTop = overlay.scrollTop - 1;
        }
    };
    CasePracticeTeamReportComponent.prototype.subWrapOneOut = function () {
        // $('#subWrapOne').fadeOut(function () {
        //     $('#subWrapTwo').fadeIn();
        // });
        var _this = this;
        $('#subWrapOne').fadeOut(200);
        $('#subWrapTwo').show();
        this.tourReviewShow = false;
        setTimeout(function () {
            _this.subWrapTwoShow = true;
            _this.btnWrapShow = true;
            _this.pathClickable = true;
        }, 500);
    };
    CasePracticeTeamReportComponent.prototype.tourReviewBoxOut = function () {
        $('#tourReviewShade').fadeOut();
        this.tourReviewBoxShow = false;
        $('#closeBtn1').fadeOut();
        this.pathClickable = true;
    };
    CasePracticeTeamReportComponent.prototype.tourReviewBoxIn = function () {
        this.pathClickable = false;
        $('#tourReviewShade').fadeIn();
        // $('#tourReviewBox').fadeIn();
        this.tourReviewBoxShow = true;
        $('#closeBtn1').fadeIn();
    };
    CasePracticeTeamReportComponent.prototype.bestPathIn = function () {
        if (!this.pathClickable) {
            return;
        }
        // $('#bestPathBox').fadeIn();
        $('#closeBtn2').fadeIn();
        this.bestPathBoxShow = true;
        $('#shade').fadeIn();
    };
    CasePracticeTeamReportComponent.prototype.slideBestPathBox = function (dom) {
        var target = $(dom).find('.sectionSlideTxt').text();
        var cls = $(dom).data('target');
        if (target === '展开') {
            $(dom).find('.sectionSlideTxt').text('收起');
            $(dom).find('.sectionSlideTriangle').addClass('rotate180');
            $('.' + cls).removeClass('hidden');
            $(dom).find('.sectionIcon').removeClass('opacity100');
        }
        else {
            var scrollDistance = $('.' + cls).offset().top - $('#bestPathBox').offset().top + $('#bestPathBox').scrollTop();
            $('#bestPathBox').animate({
                scrollTop: scrollDistance
            }, 500);
            // $('#bestPathBox').scrollTop(scrollDistance);
            $(dom).find('.sectionSlideTxt').text('展开');
            $(dom).find('.sectionSlideTriangle').removeClass('rotate180');
            $('.' + cls).addClass('hidden');
            $(dom).find('.sectionIcon').addClass('opacity100');
        }
    };
    CasePracticeTeamReportComponent.prototype.bestPathOut = function () {
        // $('#bestPathBox').fadeOut();
        $('#closeBtn2').fadeOut();
        this.bestPathBoxShow = false;
        $('#shade').fadeOut();
    };
    CasePracticeTeamReportComponent.prototype.analysisBoxIn = function (i) {
        var _this = this;
        this.pathClickable = false;
        this.currentName = this.report[i].name;
        this.currentDescription = this.report[i].description;
        this.currentTotal = this.report[i].total;
        this.currentAnalysis = this.report[i].analysis;
        $('#analysisShade').fadeIn();
        $('#analysisShade').fadeIn();
        // $('#analysisBox').fadeIn();
        $('#analysisContent').scrollTop(0);
        this.analysisBoxShow = true;
        // $('#subWrapTwo').css({'overflow':'hidden'});
        // $('body').css('overflow-y', 'hidden');
        setTimeout(function () {
            _this.starShow = true;
        }, 300);
    };
    CasePracticeTeamReportComponent.prototype.analysisBoxOut = function () {
        $('#analysisShade').fadeOut();
        this.analysisBoxShow = false;
        // $('body').css('overflow-y', 'scroll');
        this.starShow = false;
        this.pathClickable = true;
    };
    CasePracticeTeamReportComponent.prototype.goToList = function () {
        if (this.goToListClickedStatus || !this.pathClickable) {
            return;
        }
        else {
            this.goToListClickedStatus = true;
        }
        var link = ['case-practice-team', this.learningPathId, this.practiceMetaId, 1, this.multiExerciseMetaId];
        if (this.type) {
            this.router.navigate(link, { queryParams: { type: 'huatek' } });
        }
        else {
            this.router.navigate(link);
        }
    };
    CasePracticeTeamReportComponent.prototype.linkToPostSurvey = function () {
        var _this = this;
        this.apiService.ajax({
            'type': 'get',
            'url': '/ddilearner/v1/getLearningPathMetaId/' + this.learningPathId
        }).subscribe(function (result) {
            _this.learningPathMetaId = result.data;
            _this.apiService.getOrCreateLearningPath(_this.learningPathMetaId).subscribe(function (result) {
                _this.learningPath = result;
                if (_this.learningPath.subItems.length == 3) {
                    _this.apiService.ajax({
                        'type': 'get',
                        'url': '/sr/learningtour',
                    }).subscribe(function (result) {
                        _this.learningTour = result;
                        var link = ['survey', _this.learningTour.tour_id, 3, 2];
                        _this.router.navigate(link);
                    });
                }
                else {
                    var link = ['survey', _this.learningPath.id, _this.learningPath.subItems[4].surveyMetaId, 1];
                    _this.router.navigate(link);
                }
            });
        });
    };
    return CasePracticeTeamReportComponent;
}());
export { CasePracticeTeamReportComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-team-report/case-practice-team-report.component.ts.pre-build-optimizer.js